import { NonRecoverableErrorsClient } from '../list/types';
import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { HttpResponseList } from 'shell/models/http-response';
import { NonRecoverableError } from 'shell/models/non-recoverable-errors';

export interface NonRecoverableErrors {
  pageInfo:
    | {
        totalCount: number;
        page: number;
        pageSize: number;
      }
    | undefined;
  nonRecoverableErrors: Array<NonRecoverableErrorsClient>;
}

export const transformNonRecoverableErrors = (
  response: AxiosResponse<HttpResponseList<NonRecoverableError>>
): NonRecoverableErrors => {
  const data = response.data.payload?.list || [];
  const pageInfo = response.data.payload?.pageInfo;

  if (pageInfo) {
    pageInfo.page = pageInfo.page / pageInfo.pageSize;
  }

  return {
    pageInfo,
    nonRecoverableErrors: data.map((eventError: NonRecoverableError) => ({
      id: eventError?.jmsMessageID || '',
      api: eventError?.iscrizioneEvento?.dsSpecEventConsumer || '',
      operatorCode: eventError?.user || '',
      microService: eventError?.iscrizioneEvento?.dsEventConsumerLocation || '',
      dataTime: eventError?.iscrizioneEvento?.timestampInserimento
        ? DateTime.fromISO(eventError?.iscrizioneEvento?.timestampInserimento).toFormat(
            'dd/MM/yyyy'
          )
        : '',
      hidden: {
        delete: true,
        edit: true,
      },
    })),
  };
};
